import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { HEADER_BLUE_LOGO } from '../../../assets/assets_constant';
import { HEADER_WHITE_LOGO } from '../../../assets/assets_constant';

declare const lucide: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() headerLogo;
  isCollapsedButton = false; // inital Load toggeler off
  isHomePage = true;
  isContactUsPage = false;
  @Output() isCollapsed  = new EventEmitter();
  constructor(private router: Router) {
    this.router.events.subscribe( (event: Event) => {
      if (event instanceof NavigationStart) {
        // Always use the home-style header across all pages
        this.isHomePage = true;
        this.isContactUsPage = event.url === '/contact-us';
      }
  });
    this.isCollapsed.emit(!this.isCollapsed);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.initializeLucideIcons();
  }

  onToggle() {
    this.isCollapsedButton = !this.isCollapsedButton;
    this.isCollapsed.emit(this.isCollapsedButton);
    
    // Reinitialize icons when menu toggles
    setTimeout(() => {
      this.initializeLucideIcons();
    }, 100);
  }

  initializeLucideIcons() {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }

    // Re-initialize icons after a short delay to ensure DOM is ready
    setTimeout(() => {
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
    }, 100);
  }
}
